const API_BASE_URL = 'https://pwa-backend.fenrir-tech.fr';
const VAPID_PUBLIC_KEY = 'BGJsNDAWd9UG8wdkVNO6qJea8piNn-akDbUu6YIwS8QyrSMBWW2EuF4QMJUNTK3l9JOPH8bLUvQG7L1JbaPF9P0';

// Enregistre le service worker pour la mise en cache et le mode hors ligne
export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          console.log('Service Worker enregistré avec succès :', registration.scope);
        })
        .catch((error) => {
          console.error('Erreur lors de l\'enregistrement du Service Worker :', error);
        });
    });
  }
}

export async function registerPushNotifications() {
  if (!('serviceWorker' in navigator)) {
    console.error('Service Workers ne sont pas supportés dans ce navigateur.');
    return;
  }

  if (!('PushManager' in window)) {
    console.error('Les notifications push ne sont pas supportées dans ce navigateur.');
    return;
  }

  try {
    const registration = await navigator.serviceWorker.ready;

    // Subscribe to push notifications
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });

    console.log('Objet de souscription :', subscription);

    // Extract keys from the subscription
    const subscriptionJson = subscription.toJSON();
    const { endpoint, keys } = subscriptionJson;

    console.log('Subscription keys:', keys);

    // Send subscription to the backend
    await fetch(`${API_BASE_URL}/users/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({
        endpoint,
        keys,
      }),
    });

    console.log('Souscription aux notifications push enregistrée avec succès.');
    alert('Vous êtes maintenant abonné aux notifications push.');
  } catch (error) {
    console.error('Erreur lors de la souscription aux notifications push :', error);
    alert('Impossible de s\'abonner aux notifications push.');
  }
}

// Fonction utilitaire pour convertir une clé VAPID
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

// Désenregistrer le service worker
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// Register Background Sync
navigator.serviceWorker.ready.then((registration) => {
  if ('sync' in registration) {
    registration.sync.register('sync-data').then(() => {
      console.log('Background Sync registered!');
    }).catch((error) => {
      console.error('Background Sync registration failed:', error);
    });
    window.addEventListener('online', () => {
      registration.sync.register('sync-recipes').then(() => {
        console.log('Synchronisation des recettes hors ligne enregistrée.');
      }).catch((error) => {
        console.error('Erreur lors de l\'enregistrement de la synchronisation :', error);
      });
    });
  }

  // Envoyez le token au service worker
  const token = localStorage.getItem('token');
  if (token) {
    registration.active.postMessage({ type: 'SET_TOKEN', token });
  }
});

async function requestNotificationPermission() {
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Notification permission not granted.');
  }
}

// Register Periodic Sync
navigator.serviceWorker.ready.then(async (registration) => {
  try {
    await requestNotificationPermission(); // Request notification permissions
    if ('periodicSync' in registration) {
      registration.periodicSync.register('refresh-content', {
        minInterval: 24 * 60 * 60 * 1000, // 1 day in milliseconds
      }).then(() => {
        console.log('Periodic Sync registered!');
      }).catch((error) => {
        if (error.name === 'NotAllowedError') {
          console.error('Periodic Sync registration failed: Permission denied.');
        } else {
          console.error('Periodic Sync registration failed:', error);
        }
      });
    } else {
      console.log('Periodic Sync is not supported in this browser.');
    }
  } catch (error) {
    console.error('Periodic Sync registration failed:', error);
  }
});